import React from "react";
import styles from "./IncidentItem.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Link } from "react-router-dom";

/**
 * Interactive component.
 * Displays the information of an incident.
 * Clicking on the incident number will take the user to the incident details page.
 * Clicking on the IBO number will take the user to the IBO file page
 */
export function IncidentItem({ index, IncidentDetails, onClick, onIboClick }) {
  const shortNumber = IncidentDetails.id.substring(0, 8) + "...";

  return (
    <div
      className={classNames(styles.container, index % 2 !== 0 && styles.gray)}
    >
      <div className={styles.item}>
        <Link to={`/security/incident/${IncidentDetails.id}`}>
          <span className={styles.link} onClick={onClick}>
            {shortNumber}
          </span>
        </Link>
      </div>
      <div className={styles.item}>{IncidentDetails.status}</div>
      <div className={styles.item}>{IncidentDetails.problemType}</div>
      <div className={styles.item}>{IncidentDetails.severity}</div>
      <div className={styles.item}>
        <Link
          to={`/security/ibo/${IncidentDetails.complaintAgainst.iboNumber}`}
        >
          <span className={styles.link} onClick={onClick}>
            {IncidentDetails.complaintAgainst.iboNumber}
          </span>
        </Link>
      </div>
      <div className={styles.item}>{IncidentDetails.caseOwner}</div>
      {/* <div> */}
      <div className={styles.item}>{IncidentDetails.createdAt}</div>
      {/* </div> */}
    </div>
  );
}

IncidentItem.propTypes = {
  /**
   * Determines the background color of the item.
   * If odd, background is #EFEFEF.
   */
  index: PropTypes.number,
  /**
   * Object with details about the incident.
   */
  IncidentDetails: PropTypes.shape({
    id: PropTypes.string,
    status: PropTypes.string,
    problemType: PropTypes.string,
    severity: PropTypes.string,
    iboNum: PropTypes.string,
    caseOwner: PropTypes.string,
    createdAt: PropTypes.string,
  }),
  /**
   * Function called when the incident number is clicked.
   */
  onClick: PropTypes.func,
  /**
   * Function called when the IBO number is clicked.
   */
  onIboClick: PropTypes.func,
};
